module.exports = __webpack_public_path__ + "img/133ne.88c1b4f8.svg";